/**
 * Skip-link — first focusable element in the document. Lets keyboard users
 * jump past the sidebar straight to <main id="main">. Visually hidden until
 * focused, then floats top-left.
 */
export function SkipLink() {
  return (
    <a
      href="#main"
      className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-dex-bg-elevated focus:px-3 focus:py-2 focus:text-sm focus:font-medium focus:text-dex-text-primary focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-dex-accent"
    >
      Skip to content
    </a>
  );
}
